<template>
  <div
    class="relative grid w-full text-xs"
    :class="[
      { 'bg-ontick-steel-200 dark:bg-[#171E27BF]': type.includes('portfolio') },
      nameColSpan === 2
        ? `grid-cols-${activeHeadersLength + 1}`
        : `grid-cols-${activeHeadersLength}`,
    ]"
  >
    <div>
      <div class="td !gap-0" v-if="type !== 'portfolio-component'">
        <status-indicator-component
          :status="investment.status"
          :position="
            type === 'portfolio-master'
              ? portfolioPosition
              : investment.position_status
          "
          :error="toggle_disabled"
          class="mr-2"
        />
        <ontick-toggle-component
          v-show="investment.status != 'HIDDEN'"
          :class="toggle_disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
          :active="investment.status == 'RUNNING' ? true : false"
          :block="toggle_disabled"
          size="sm"
          @switch="
            $emit('toggleSwitch', {
              investmentId: investment.investment_id,
              investmentStatus: investment.status,
              toogle: (toggle_disabled =
                investment.status === 'RUNNING' ? false : toggle_disabled),
            }),
              selectedParams({
                value: typed_volume || investment.curr_volume,
                item: investment,
              })
          "
        />
        <ontick-form-dropdown
          offset
          content="Outras opções"
          v-tippy="{ arrow: true, theme: 'green' }"
          :position="'left'"
          :optionCard="true"
          :disabledOptionDefault="true"
          :optionInitial="optionDefault"
          :options="optionsSelect"
          :footer="investment.investment_id"
          @optionSelected="optionSelected($event, investment)"
          bg="bg-transparent"
        ></ontick-form-dropdown>
      </div>
    </div>
    <div :class="`col-span-${nameColSpan}`">
      <div
        class="td"
        :content="
          type === 'portfolio-component'
            ? `Componente de ${getParentName}`
            : investment.strategy_name
        "
        v-tippy="{ arrow: true, theme: 'green' }"
      >
        <template v-if="type !== 'portfolio-component'">
          <img
            v-if="investment.partner_badge"
            :src="investment.partner_badge"
            class="h-4 w-4"
          />

          <span class="font-semibold">
            {{ investment.strategy_name }}
          </span>
        </template>
        <template v-else>
          <span class="text-[10px] font-semibold text-gray-500">
            {{
              getInvestments.find(
                (item) => item.investment_id === investment.parent_id
              ).strategy_name
            }}
          </span>
        </template>
        <span v-if="debug" class="text-[10px] uppercase text-gray-500">
          {{ investment.investment_id }}
        </span>
      </div>
    </div>
    <div>
      <div v-if="type === 'portfolio-master'" class="td">
        <span
          class="bg-ontick-blue-900 text-ontick-blue-300 flex items-center justify-center rounded-sm px-2 py-0.5 text-xs"
        >
          {{
            investment.strategy_symbol.length > 1
              ? "Vários"
              : investment.strategy_symbol[0]
          }}
        </span>
      </div>
      <div v-else class="td">
        <span
          class="bg-ontick-blue-900 text-ontick-blue-300 flex items-center justify-center rounded-sm px-2 py-0.5 text-xs"
        >
          {{
            investment.strategy_symbol === "ANY"
              ? "Vários"
              : investment.strategy_symbol
          }}
        </span>
      </div>
    </div>
    <div
      v-if="headers.find((item) => item.key === 'strategy_timeframe').active"
    >
      <div v-if="!type.includes('portfolio')" class="td">
        <span
          class="bg-ontick-teal-600 text-ontick-teal-50 flex items-center justify-center rounded-sm px-2 py-0.5 text-xs"
        >
          {{
            investment.strategy_timeframe === "ANY"
              ? "Vários"
              : investment.strategy_timeframe
          }}
        </span>
      </div>
    </div>
    <div>
      <div v-if="type === 'portfolio-master'" class="td gap-1">
        <span>
          {{
            investment.sub_strategies.some(
              (item) => item.position_status !== "Zerado"
            )
              ? "Posicionado"
              : "Zerado"
          }}
        </span>
      </div>
      <div v-else class="td">
        <template v-if="type === 'portfolio-component'">
          <span
            v-tippy="{ theme: 'green', arrow: true }"
            :content="positionText(investment.position_status).label"
            :class="{
              'bg-ontick-yellow-600 text-ontick-graphite-500 flex h-4 w-4 items-center justify-center rounded text-xs font-semibold':
                investment.position_status !== 'Zerado',
            }"
          >
            {{
              positionText(investment.position_status).minimal ||
              investment.position_status
            }}
          </span>
        </template>
        <span
          v-else-if="investment.curr_positions"
          v-tippy="{ theme: 'green', arrow: true }"
          :content="multiSymbolPosition"
        >
          {{ multiSymbolPosition }}
        </span>
        <span
          v-else
          v-tippy="{ theme: 'green', arrow: true }"
          :content="positionText(investment.position_status).label"
          :class="{
            'bg-ontick-yellow-600 text-ontick-graphite-500 flex h-4 w-4 items-center justify-center rounded text-xs font-semibold':
              investment.position_status !== 'Zerado',
          }"
        >
          {{
            positionText(investment.position_status).minimal ||
            investment.position_status
          }}
        </span>
      </div>
    </div>
    <div :class="{ 'font-bold': type === 'portfolio-master' }" class="td">
      <span
        v-if="investment.strategy_symbol === 'ANY' && investment.curr_positions"
      >
        {{
          (Number(
            investment.curr_positions.reduce(
              (acc, curr) =>
                acc + curr.position_volume * curr.position_price_avg,
              0
            )
          ) || 0) | currency
        }}
      </span>
      <template v-else-if="investment.strategy_market === 'Equities'">
        <span
          v-if="investment.volume_type === 'FIN_VOLUME'"
          :content="`Quantidade a ser definida na abertura da posição (R$${investment.curr_volume})`"
          v-tippy="{ arrow: true, theme: 'green' }"
        >
          {{ investment.position_volume || "-/-" }}
        </span>

        <span
          v-else-if="investment.volume_type === 'QUANTITY'"
          content="Quantidade de ações (posicionados/parametrizados)"
          v-tippy="{ arrow: true, theme: 'green' }"
        >
          {{ investment.position_volume || "-" }}/{{ investment.param_volume }}
        </span>
      </template>
      <span v-else>
        {{ volume }}
      </span>
    </div>
    <div :class="{ 'font-bold': type === 'portfolio-master' }" class="td">
      <template v-if="type === 'portfolio-master'">
        <ontick-loading-ellipsis-component
          v-if="investment.open_pnl === null"
        />
        <i
          v-else-if="investment.open_pnl !== 0"
          :class="
            investment.open_pnl > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        />
        <span class="whitespace-nowrap">
          {{ investment.open_pnl | currency }}
        </span>
      </template>
      <template
        v-else-if="
          investment.strategy_symbol === 'ANY' && investment.curr_positions
        "
      >
        <ontick-loading-ellipsis-component
          v-if="investment.open_pnl === null"
        />
        <i
          v-else-if="investment.open_pnl !== 0"
          :class="
            investment.open_pnl > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        />
        <span class="whitespace-nowrap">
          {{
            multiSymbolPosition === "Zerado"
              ? 0
              : investment.open_pnl | currency
          }}
        </span>
      </template>
      <template v-else>
        <ontick-loading-ellipsis-component
          v-if="investment.open_pnl === null"
        />
        <i
          v-else-if="investment.open_pnl !== 0"
          :class="
            investment.open_pnl > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        />
        <span class="whitespace-nowrap">
          {{
            investment.position_status === "Zerado"
              ? 0
              : investment.open_pnl | currency
          }}
        </span>
      </template>
    </div>
    <div :class="{ 'font-bold': type === 'portfolio-master' }" class="td">
      <template v-if="type === 'portfolio-master'">
        <i
          v-if="portfolioMasterClosedPnl !== 0"
          :class="
            portfolioMasterClosedPnl > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        ></i>
        <span class="whitespace-nowrap">
          {{ portfolioMasterClosedPnl | currency }}
        </span>
      </template>
      <template v-else>
        <i
          v-if="
            (investment.closed_pnl || 0) + (investment.position_profit || 0) !==
            0
          "
          :class="
            (investment.closed_pnl || 0) + (investment.position_profit || 0) > 0
              ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
              : 'text-ontick-red-500 rotate-180'
          "
          v-html="$icons.arrow_drop"
        ></i>
        <span class="whitespace-nowrap">
          {{
            ((investment.closed_pnl || 0) + (investment.position_profit || 0))
              | currency
          }}
        </span>
      </template>
    </div>
    <div>
      <div v-if="type !== 'portfolio-component'" class="td">
        <template>
          <span
            v-if="!status.length"
            class="font-bold uppercase"
            content="Investimento rodando"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            Ativo
          </span>
          <span
            v-else-if="status.length === 1"
            class="font-bold uppercase"
            :class="status[0].color"
            :content="status[0].tooltip"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            {{ status[0].name }}
          </span>
          <template v-else-if="status.length > 1">
            <span
              v-for="item in status"
              :key="item.name"
              class="px-2 font-bold uppercase"
              :class="item.color"
              :content="item.tooltip"
              v-tippy="{ arrow: true, theme: 'green' }"
            >
              {{ item.name.charAt(0) }}
            </span>
          </template>
        </template>
      </div>
    </div>

    <div
      v-if="headers.find((item) => item.key === 'max_daily_loss').active"
      class="td"
    >
      <p
        v-if="investment.strategy_market === 'Equities'"
        class="whitespace-nowrap"
        content="Ganho por operação"
        v-tippy="{ arrow: true, theme: 'green' }"
      >
        {{ (investment.max_loss * -1) | currency
        }}<span
          v-if="investment.limit_type === 'PER_TRADE'"
          class="text-xs text-gray-500"
          >/op.</span
        >
      </p>
      <template v-else>
        <p class="whitespace-nowrap" v-if="investment.max_daily_loss">
          {{
            investment.max_daily_loss
              ? investment.max_daily_loss
              : "-" | currency
          }}
        </p>
        <p
          v-else
          class="flex items-center space-x-2"
          content="Estratégia sem limite de perda configurado"
          v-tippy="{
            arrow: true,
            theme: 'red',
          }"
        >
          <span>N/D</span>
          <i v-html="$icons.red_alert_sm"></i>
        </p>
      </template>
    </div>
    <div
      v-if="headers.find((item) => item.key === 'max_daily_gain').active"
      class="td"
    >
      <p
        v-if="investment.strategy_market === 'Equities'"
        class="whitespace-nowrap"
        content="Ganho por operação"
        v-tippy="{ arrow: true, theme: 'green' }"
      >
        {{ investment.max_gain | currency
        }}<span
          v-if="investment.limit_type === 'PER_TRADE'"
          class="text-xs text-gray-500"
          >/op.</span
        >
      </p>
      <template v-else>
        <p class="whitespace-nowrap" v-if="investment.max_daily_gain">
          {{
            investment.max_daily_gain
              ? investment.max_daily_gain
              : "-" | currency
          }}
        </p>
        <p v-else class="flex items-center">
          <span>N/D</span>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import * as icons from "@/app/assets/icons/investments";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    statusIndicatorComponent: () =>
      import("../card-investment/status-indicator.component.vue"),
    OntickToggleComponent: () =>
      import("../../ontick-toggle/ontick-toggle.component.vue"),
    OntickLoadingEllipsisComponent: () =>
      import(
        "../../../../../shared/components/basic/ontick-loading-ellipsis.component.vue"
      ),
  },

  props: {
    investment: {
      type: Object,
    },
    nameColSpan: {
      type: Number,
    },
    headers: {
      type: Array,
    },
    isPortfolioComponent: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "strategy",
    },
  },

  data() {
    return {
      typed_volume: this.investment.curr_volume,
      toggle_disabled: true,
      optionDefault: {
        icon: icons.details,
        label: null,
      },
      optionsSelect: [
        { icon: icons.editParams, label: "Parâmetros" },
        { icon: icons.performance, label: "Histórico" },
        {
          icon: icons.removeInvestment,
          label:
            this.investment.status != "HIDDEN" ? "Arquivar" : "Desarquivar",
        },
      ],
      dropdownIsActive: false,
      debug: true,
    };
  },

  computed: {
    ...mapGetters({ getInvestments: "investment/getInvestments" }),
    activeHeadersLength() {
      return this.headers.filter(
        (item) => !item.optional || (item.optional && item.active)
      ).length;
    },
    volume() {
      if (this.type === "portfolio-master") {
        return `${this.investment.sub_strategies
          .map((item) => {
            return item.position_volume || 0;
          })
          .reduce((acc, curr) => {
            return acc + curr;
          }, 0)}/${this.investment.max_exposure}`;
      } else if (this.type === "portfolio-component") {
        return this.investment.position_volume || "-";
      } else if (this.investment.position_volume) {
        return `${this.investment.position_volume}/${this.investment.param_volume}`;
      } else {
        return `-/${this.investment.param_volume}`;
      }
    },
    portfolioPosition() {
      if (
        this.investment.sub_strategies.every(
          (item) => item.position_status === "Zerado"
        )
      ) {
        return "Zerado";
      }
      return "Posicionado";
    },
    portfolioMasterPnl() {
      if (this.type === "portfolio-master") {
        return this.investment.sub_strategies.reduce(
          (acc, curr) => acc + (curr.open_pnl || 0),
          0
        );
      }
      return 0;
    },
    portfolioMasterClosedPnl() {
      if (this.type === "portfolio-master") {
        return this.investment.sub_strategies.reduce((acc, curr) => {
          return acc + ((curr.closed_pnl || 0) + (curr.position_profit || 0));
        }, 0);
      }
      return 0;
    },
    getParentName() {
      return this.getInvestments.find(
        (item) => item.investment_id === this.investment.parent_id
      ).strategy_name;
    },
    multiSymbolPosition() {
      if (this.investment.curr_positions.length) return "Posicionado";
      return "Zerado";
    },
  },

  methods: {
    ...mapActions({
      selectedParams: "investment/selectedParams",
      removeMask: "investment/removeMask",
    }),
    positionText(value) {
      if (value == "BUY" || value == "Comprado") {
        return {
          label: "Comprado",
          minimal: "C",
        };
      } else if (value == "SELL" || value == "Vendido") {
        return { label: "Vendido", minimal: "V" };
      } else {
        return { label: "Zerado" };
      }
    },
    status() {
      let statuses = [];
      if (this.investment.mask_gain) {
        statuses.push({
          name: "Gain",
          color: "text-ontick-green-700 dark:text-ontick-green-600",
          tooltip: "Limite de ganho atingido",
        });
      }
      if (this.investment.mask_loss) {
        statuses.push({
          name: "Loss",
          color: "text-ontick-red-700 dark:text-ontick-red-600",
          tooltip: "Limite de perda atingido",
        });
      }
      if (this.investment.mask_time) {
        statuses.push({
          name: "Tempo",
          color: "text-ontick-teal-700 dark:text-ontick-teal-600",
          tooltip: "Limite de tempo atingido",
        });
      }
      if (this.investment.mask_limit) {
        statuses.push({
          name: "Limite",
          color: "text-ontick-pink-700 dark:text-ontick-pink-600",
          tooltip: "Limite operacional atingido",
        });
      }
      return statuses;
    },
    optionSelected(event, investment) {
      switch (event.label) {
        case "Parâmetros":
          this.$router.push({
            path: "/investments/" + Number(investment.investment_id) + "/edit",
          });

          break;
        case "Histórico":
          this.$router.push({
            name: "Histórico",
            params: {
              id: Number(investment.investment_id),
              label: investment.strategy_name,
            },
          });
          break;
        case "Arquivar":
          if (investment.status == "STOPPED") {
            this.$api
              .post(this.$endpoint.INVESTMENT_HIDE, {
                investment_id: Number(investment.investment_id),
              })
              .then((response) => {
                this.$swal({
                  title: response.data.msg,
                  icon: "success",
                  icon: "success",
                  iconHtml: this.$icons.swal_success,
                });
                this.getInvestments();

                // this.$emit("reload", { investmentActiveOrHidden: "ACTIVE" });
              });
          } else if (investment.status == "RUNNING") {
            this.$swal({
              title: "Você deve parar o investimento para ocultá-lo",
              icon: "error",
              timer: 8000,
            });
          }
          break;
        case "Desarquivar":
          if (investment.status == "HIDDEN") {
            this.$api
              .post(this.$endpoint.INVESTMENT_SHOW, {
                investment_id: Number(investment.investment_id),
              })
              .then((response) => {
                this.$swal({
                  icon: "success",
                  icon: "success",
                  iconHtml: this.$icons.swal_success,
                  title: response.data.msg,
                });
                // this.$emit("reload", { investmentActiveOrHidden: "HIDDEN" });
                this.getInvestments();
              });
          }
          break;
      }
    },
    closeMask(investment_id, mask) {
      this.removeMask({
        investment_id,
        mask,
      });
      if (mask.fixedMask) {
        this.$api
          .post(this.$endpoint.DISMISS_MASK, {
            investment_id: investment_id,
            notification_type: mask.type,
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.td {
  @apply flex h-12 w-full items-center gap-1 py-2 px-4;
}
</style>
